const FormInput = ({
  label,
  id,
  value,
  setValue,
  maxLength,
  type = "text",
  min,
  onBlur,
  disabled,
}: {
  label: string;
  id: string;
  value: string;
  setValue: (newValue: string) => void;
  maxLength?: number;
  disabled?: boolean;
  min?: number;
  onBlur?: () => void;
  type?: "text" | "date" | "number" | "tel" | "email";
}) => (
  <div className="flex flex-col w-56">
    <label htmlFor={id} className="pb-1">
      {label}
    </label>
    <input
      className="leading-tight py-1 px-0 form-input appearance-none border-0 border-b text-xs focus:outline-none focus:shadow"
      name={id}
      id={id}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      required
      maxLength={maxLength}
      type={type}
      min={min}
      disabled={disabled}
      onBlur={onBlur}
    />
  </div>
);

export default FormInput;
